import { width, height, sizeNormal } from "./Drawer"
import { AcroFormCheckBox, AcroFormTextField } from "jspdf"

export const tfH = 8

export function getAcroFormCheckBox(x, y, width, height, checked = true) {
	let afcb = new AcroFormCheckBox()
	afcb.x = x
	afcb.y = y
	afcb.width = width
	afcb.height = height
	afcb.appearanceState = checked ? "On" : "Off"
	return afcb
}

export function getAcroFormTextField(x, y, width, height, text) {
	let aftf = new AcroFormTextField()
	aftf.fontSize = 7
	aftf.x = x
	aftf.y = y
	aftf.width = width
	aftf.height = height
	aftf.value = text
	return aftf
}

export function drawMargins(doc) {
	doc.line(width / 3, 0, width / 3, height)
	doc.line((width * 2) / 3, 0, (width * 2) / 3, height)
}

export function drawTitle(doc, title, margin) {
	doc.setFontSize(25)
	doc.setFont(undefined, "bold")
	doc.text(width / 2, 15, title, "center")
	doc.setLineWidth(0.5)
	doc.line(margin, 5, width - margin, 5)
	doc.line(margin, 20, width - margin, 20)
	doc.line(margin, 5, margin, 20)
	doc.line(width - margin, 5, width - margin, 20)
}

export function drawTextField(doc, title, texte, x, y, w, drawTitle = true) {
	if (drawTitle) {
		doc.setFontSize(sizeNormal)
		doc.setFont(undefined, "bold")
		doc.text(x, y, title, "left")
	}
	doc.setFont(undefined, "normal")
	doc.text(x + w / 2, y + (tfH * 2) / 3, texte, "center")
	doc.setLineWidth(0.1)
	doc.line(x, y + tfH, x + w, y + tfH)
}

export function drawTextField2(
	doc,
	title,
	texte,
	x,
	y,
	w,
	drawTitle = true,
	important = false,
) {
	if (drawTitle) {
		doc.setFontSize(sizeNormal)
		doc.setFont(undefined, "normal")
		doc.text(x, y, title, "left")
	}
	doc.setFont(undefined, "bold")
	doc.text(x + w / 2, y + (tfH * 2) / 3, texte, "right")
	doc.setLineWidth(0.1)
	if (important) doc.setLineWidth(0.5)
	doc.line(x, y + tfH - 1, x + w, y + tfH - 1)
	doc.line(x, y + 1, x + w, y + 1)
	doc.line(x, y + 1, x, y + tfH - 1)
	doc.line(x + w, y + 1, x + w, y + tfH - 1)
}

export function drawTextField3(
	doc,
	title,
	texte,
	x,
	y,
	w,
	drawTitle = true,
	important = false,
) {
	if (drawTitle) {
		doc.setFontSize(sizeNormal)
		doc.setFont(undefined, "normal")
		doc.text(x, y, title, "left")
	}
	doc.setFontSize(sizeNormal)
	doc.setFont(undefined, "normal")
	doc.text(x + w - 2, y + 5, texte, "right")
	doc.setLineWidth(0.1)
	if (important) doc.setLineWidth(0.5)
	doc.line(x, y + tfH - 1, x + w, y + tfH - 1)
	doc.line(x, y + 1, x + w, y + 1)
	doc.line(x, y + 1, x, y + tfH - 1)
	doc.line(x + w, y + 1, x + w, y + tfH - 1)
}

export function drawTextFieldRow(doc, title, texte, x, y, w, drawLine = true) {
	doc.setFontSize(sizeNormal)
	doc.setFont(undefined, "bold")
	doc.text(x, y + (tfH * 2) / 3, title, "left")
	doc.setFont(undefined, "normal")
	let tempWidth = (w * 2) / 3 - 2
	doc.text(x + tempWidth + 4, y + (tfH * 2) / 3, texte, "center")
	if (drawLine) {
		doc.setLineWidth(0.1)
		doc.line(x + w / 3 + 4, y + tfH, x + w, y + tfH)
	}
}

export function drawTextFieldSimple(doc, texte, x, y, align = "left") {
	doc.setFontSize(sizeNormal)
	doc.setFont(undefined, "normal")
	doc.text(x, y + (tfH * 2) / 3, texte, align)
}
